import React from 'react'
import { Routes, Route } from 'react-router-dom'

import PropertiesIndex from './properties_index.jsx'
import PropertiesNew from './properties_new.jsx'
import PropertiesEdit from './properties_edit.jsx'

let PropertiesRouter = () => (
  <Routes>
    <Route exact path="/"          element={ <PropertiesIndex /> } />
    <Route exact path="/new"      element={ <PropertiesNew /> } />
    <Route       path="/:id/edit" element={ <PropertiesEdit /> } />
  </Routes>
)

export default PropertiesRouter
